export enum EApiRequestDirection {    
    Incoming,
    Outcoming
}